import { Category } from '@idea2app/ai-work-order-service';
import { Icon } from 'idea-react';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Column, RestTable } from 'mobx-restful-table';
import { Component } from 'react';
import { Button, Card, Container, Modal } from 'react-bootstrap';

import { AIClassifier } from '../component/AIClassificationModal';
import categoryStore from '../model/Category';
import { i18n, t } from '../model/Translation';

@observer
export class CategoryPage extends Component {
    @observable
    accessor showAIModal = false;

    @computed
    get columns(): Column<Category>[] {
        return [
            {
                key: 'businessType',
                type: 'text',
                required: true,
                renderHead: t('business_type')
            },
            {
                key: 'level1Category',
                type: 'text',
                required: true,
                renderHead: t('level1_category')
            },
            {
                key: 'level2Category',
                type: 'text',
                required: true,
                renderHead: t('level2_category')
            },
            {
                key: 'level3Category',
                type: 'text',
                required: true,
                renderHead: t('level3_category')
            },
            {
                key: 'level3Subdivision',
                type: 'text',
                renderHead: t('level3_detail'),
                renderBody: ({ level3Subdivision }) => level3Subdivision || '-'
            },
            {
                key: 'notes',
                type: 'text',
                renderHead: t('remark'),
                renderBody: ({ notes }) => notes || '-'
            },
            {
                key: 'department',
                type: 'text',
                renderHead: t('department')
            },
            {
                key: 'professionalOffice',
                type: 'text',
                renderHead: t('specialist_office')
            },
            {
                key: 'sortOrder',
                type: 'number',
                renderHead: t('sort_order')
            }
        ];
    }

    handleAIClassify = () => {
        this.showAIModal = true;
    };

    handleCloseAIModal = () => {
        this.showAIModal = false;
    };

    render() {
        return (
            <Card className="m-3" body>
                <div className="mb-3 d-flex justify-content-between align-items-center">
                    <Button variant="primary" onClick={this.handleAIClassify}>
                        <Icon name="stars" />
                        {t('ai_auto_classify')}
                    </Button>
                </div>
                <RestTable
                    columns={this.columns}
                    store={categoryStore}
                    translator={i18n}
                    striped
                    hover
                    editable
                    deletable
                />
                <Modal
                    show={this.showAIModal}
                    size="lg"
                    centered
                    onHide={this.handleCloseAIModal}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('ai_auto_classify')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AIClassifier
                            onComplete={this.handleCloseAIModal}
                            onCancel={this.handleCloseAIModal}
                        />
                    </Modal.Body>
                </Modal>
            </Card>
        );
    }
}
